import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "../common/modules/shared";
import { CoreModule } from "../common/modules/core";
import { UserModule } from "../common/modules/user";

import { ServicesListComponent } from "./services-list/ServicesListComponent";
import { OtherParentNavigateComponent } from "./other-parent-navigate/OtherParentNavigateComponent";
import { ParentNavigateComponent } from "./parent-navigate/ParentNavigateComponent";
import { SessionService } from "../common/modules/user/services/SessionService";
import { UserService } from "../common/modules/user/services/UserService";
import { VivaService } from "./services/VivaService";
import { EmailService } from "../asa/services/EmailService";

import { AppComponent } from "./AppComponent";
import { routing } from "./AppRouting";

@NgModule({
  imports: [BrowserModule, CoreModule, SharedModule, UserModule, routing, ],
  declarations: [
    AppComponent,
    ServicesListComponent,
    ParentNavigateComponent,
    OtherParentNavigateComponent,
  ],
  providers: [SessionService, UserService, VivaService, EmailService],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/services/AppModule.ts